window.Reverb = window.Reverb || {};
Reverb.BundledCheckout = Reverb.BundledCheckout || {};

Reverb.BundledCheckout.CreditCard = (function () {
  const showNewCardFormDataAttr = 'show-credit-card-form-on-change';
  const showNewCardFormSelector = `[data-${showNewCardFormDataAttr}]`;
  const cardRadioButtonsSelector = `${showNewCardFormSelector} :radio`;

  function init() {
    bindAddNewCreditCardChanged();
  }

  function bindAddNewCreditCardChanged() {
    $(document).on('change', cardRadioButtonsSelector, toggleAddCreditCardForm);
  }

  function toggleAddCreditCardForm(e) {
    const $slideoutEl = $($(e.target).closest(showNewCardFormSelector).data(showNewCardFormDataAttr));
    if (newCreditCardSelected()) {
      $slideoutEl.show();
    } else {
      $slideoutEl.hide();
    }
  }

  function newCreditCardSelected() {
    const $selectedButton = $(`${cardRadioButtonsSelector}:checked`);
    return $.trim($selectedButton.val()) === '';
  }

  return {
    init,
  };
}());

$(Reverb.BundledCheckout.CreditCard.init);
